import { render, staticRenderFns } from "./GigDescription.htm?vue&type=template&id=d0983dfa&scoped=true&"
import script from "./GigDescription.ts?vue&type=script&lang=js&"
export * from "./GigDescription.ts?vue&type=script&lang=js&"
import style0 from "./GigDescription.scss?vue&type=style&index=0&id=d0983dfa&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d0983dfa",
  null
  
)

export default component.exports